import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import { SidebarProvider, useSidebar } from '../context/SidebarContext';
import Sidebar from './Sidebar';

function LayoutInner() {
    const { collapsed, isMobile, toggleMobile } = useSidebar();
    const ml = isMobile ? 0 : (collapsed ? '60px' : '240px');

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Sidebar />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    ml,
                    transition: 'margin-left 0.2s ease',
                    minHeight: '100vh',
                    backgroundColor: '#f5f7fa',
                }}
            >
                {isMobile && (
                    <Box sx={{ display: 'flex', alignItems: 'center', px: 1, py: 1, backgroundColor: '#fff', borderBottom: '1px solid #e0e0e0' }}>
                        <IconButton onClick={toggleMobile} size="small">
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#0079bf', fontSize: '1rem', ml: 1 }}>
                            Media Scanner
                        </Typography>
                    </Box>
                )}
                <Outlet />
            </Box>
        </Box>
    );
}

export default function AppLayout() {
    return (
        <SidebarProvider>
            <LayoutInner />
        </SidebarProvider>
    );
}
